import React, {
  FC, useMemo, useState, useEffect,
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { Card } from 'reactstrap';
import _ from 'lodash';
import Isvg from 'react-inlinesvg';

import ArrowRightIcon from 'app/images/icons/arrow-right.svg';

import SectionGroup from 'app/components/general/SectionGroup';

import * as teamMemberSummariesActions from 'app/ducks/teamMemberSummaries/actions';
import * as teamPaymentCollectionActions from 'app/ducks/teamPaymentCollections/actions';
import * as teamPaymentRequestActions from 'app/ducks/teamPaymentRequests/actions';
import * as seasonsActions from 'app/ducks/seasons/actions';
import TeamMemberSummariesTable from 'app/components/teamMemberSummaries/TeamMemberSummariesTable';

import * as loadingSelectors from 'app/ducks/loading/selectors';
import * as teamMemberSummariesSelectors from 'app/ducks/teamMemberSummaries/selectors';
import * as organisationsSelectors from 'app/ducks/organisations/selectors';
import * as teamPaymentCollectionsSelector from 'app/ducks/teamPaymentCollections/selectors';
import * as seasonsSelectors from 'app/ducks/seasons/selectors';
import { ITeamMemberSummariesSelector } from 'app/ducks/teamMemberSummaries/types';

function selector(state): any {
  return {
    appReady: loadingSelectors.appReady(state),
    teamMemberSummaries: teamMemberSummariesSelectors.getTeamMemberSummaries(state),
    teamPaymentCollections: teamPaymentCollectionsSelector.getTeamPaymentCollections(state),
    currentOrganisation: organisationsSelectors.getCurrentOrganisation(state),
    seasons: seasonsSelectors.getSeasons(state),
    isLoading: state.payments.isLoading,
    errors: { ...state.teamMemberSummaries.backendErrors },
  };
}

const actionCreators = _.merge(teamMemberSummariesActions, seasonsActions, teamPaymentCollectionActions, teamPaymentRequestActions);

interface IProps {
  groupId: string;
  teamId: string;
  appReady: any;
  teams: ITeamsSelector;
  teamPaymentCollections: any;
  teamMemberSummaries: ITeamMemberSummariesSelector;
  seasons: any;
  seasonId: any;
  actions: any;
  currentOrganisation: any;
  isLoading: boolean;
  errors: any;
  filterStatus: string;
}

interface IState {
  numberOfCards: number;
}

const DashboardSeasonOverview: FC<IProps> = (props: IProps = {
  groupId: undefined,
  teamId: undefined,
  teamMemberSummaries: {},
  teamPaymentCollections: {},
  teams: {},
  actions: undefined,
  currentOrganisation: {},
  isLoading: false,
  appReady: false,
  errors: {},
  filterStatus: 'pending',
}) => {
  const currentSeasonId = props.seasonId !== undefined ? props.seasonId : undefined;
  const currentSeason = props.seasons?.seasonsById !== undefined ? props.seasons?.seasonsById[currentSeasonId] : undefined;

  const initialFilterConfig = {
    season: _.find(props.seasons.seasonsByIdInSelectFormat, (s) => s?.id === currentSeasonId),
  };

  useEffect(() => {
    props.actions.getAllSeasons();
  }, []);
  // TODO - Loading improvements
  return (
    <div className="row">
      <div className="col">
        <TeamMemberSummariesTable
          seasonsByIdInSelectFormat={props.seasons.seasonsByIdInSelectFormat}
          seasonsById={props.seasons.seasonsById}
          seasonIds={props.seasons.seasonIds}
          currentSeasonId={currentSeasonId}
          isLoading={props.teamMemberSummaries.isLoading}
          selectTeamMemberSummary={props.actions.selectTeamMemberSummary}
          pagination={props.teamMemberSummaries.pagination}
          teamPaymentCollectionsById={props.teamPaymentCollections.teamPaymentCollectionsById}
          teamPaymentCollectionIds={props.teamPaymentCollections.teamPaymentCollectionIds}
          isLoading={props.teamPaymentCollections.isLoading}
          selectTeamPaymentCollections={props.actions.selectTeamPaymentCollections}
          pagination={props.teamPaymentCollections.pagination}
          seasonId={currentSeasonId}
          appReady={props.appReady}
          actions={props.actions}
          // headerTitle={`${currentSeason?.name} - Season`}
          saveFilters={false}
          createReminder={undefined}
          initialFilterConfig={initialFilterConfig}
        />
      </div>
    </div>
  );
};
export default connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))(DashboardSeasonOverview);
